import React from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js'

import '../../css/player.css';

class SimpleVideoPlayer extends React.Component {
    constructor(props) {
        super(props);
    }

    playButton = () => {
      if (this.player) {
        this.player.play();
      }
    }

    initVideoJs = () => {
      const { audition } = this.props
      // instantiate Video.js
      this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
        this.src(audition.clipUrl);
      });
    }

    componentDidMount() {
      this.initVideoJs();
    }

    // destroy player on unmount
    componentWillUnmount() {
      if (this.player) {
        this.player.dispose()
      }
    }

    render() {
      const { audition } = this.props;

        return (
            <div id="video-player-container" className="clearfix video-player-container">
                <div className="full-player">
                    <div className="player-zone">
                        <div className="video-player">
                            <div id="vp_18">
                                <div id="vp_18_wrapper" className="sk-video-player">
                                  <video
                                    controls
                                    ref={ node => this.videoNode = node }
                                    id="vp_18_video_html5_api"
                                    className="video-js vjs-sk vjs-default-skin vjs-paused vp_18_video-dimensions vjs-fluid vjs-controls-enabled vjs-workinghover vjs-v6 vjs-user-active"
                                    preload="none"
                                    poster={audition.imageUrl}
                                    playinline=""
                                    tabIndex="-1"
                                  />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default SimpleVideoPlayer;
